import React from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import {store} from "./store/store";
import App from "./App";
import "./index.css";
import {BrowserRouter} from "react-router-dom";
import {AuthProvider, type AuthProviderProps} from "react-oidc-context";
import {WebStorageStateStore} from "oidc-client-ts";
import {
  oidcServiceUrl,
  oidcClientId,
  oidcPostLogoutRedirectUri,
  oidcRedirectUri,
  oidcScope,
  oidcDefaultProviderId,
  overriddenOidcDefaultProviderId,
  adminPanelBasePath
} from "./infrastructure/config";
import { globalVar } from './infrastructure/runtime';

const container = document.getElementById("react-app");

const root = createRoot(container);

const storage: Storage = globalVar('localStorage');
const SLOverriddenOidcDefaultProviderId: string = 'SL.overriddenOidcDefaultProviderId';
if(overriddenOidcDefaultProviderId === 'clr') {
  storage.removeItem(SLOverriddenOidcDefaultProviderId);
}
else {
  overriddenOidcDefaultProviderId && 
  storage.setItem(SLOverriddenOidcDefaultProviderId, overriddenOidcDefaultProviderId);
}
const idp = storage.getItem(SLOverriddenOidcDefaultProviderId) ?? oidcDefaultProviderId;
const oidcConfig: AuthProviderProps = {
  authority: oidcServiceUrl,
  client_id: oidcClientId,
  redirect_uri: oidcRedirectUri,
  post_logout_redirect_uri: oidcPostLogoutRedirectUri,
  scope: oidcScope,
  acr_values: (idp ?? "").length > 0 ? `idp:${idp}` : undefined,
  response_type: "code",
  response_mode: "query",
  monitorSession: false,
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  stateStore: new WebStorageStateStore({store: window.sessionStorage}),
  userStore: new WebStorageStateStore({store: window.sessionStorage}),
  onSigninCallback: (): void => {
    const basePath = adminPanelBasePath || '/';
    const pathname = window.location.pathname;
    let safePath = basePath;
    if (pathname.startsWith(basePath)) {
      const subPath = pathname.slice(basePath.length);
      const segments = subPath.split('/').filter(s => /^[\w\-.~]+$/.test(s));
      safePath = basePath + segments.join('/');
    }
    window.history.replaceState({}, "", safePath);
  }
};

root.render(
  <AuthProvider {...oidcConfig}>
    <React.StrictMode>
      <BrowserRouter basename={adminPanelBasePath}>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </AuthProvider>
);
